import bdaylytics from "components/utils/analytics/bdaylytics";
import { useApp, usePageVisibility, useQueryDict } from "hooks/app";
import React, { createContext, useContext, useEffect, useState } from "react";
import { syncMembership } from "services/payment-service";
import { getUser, isUser, logout } from "services/user-service";

const MemberContext = createContext({ user: {} });

export const MemberProvider = ({ children }) => {
  const { pathname, search, queryDict } = useQueryDict();
  const isVisible = usePageVisibility();
  const { showAlert } = useApp();
  const [user, setUser] = useState({});

  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (isVisible) {
      getMember();
    }
  }, [isVisible]);

  useEffect(() => {
    if (user.isSoftLoggedIn && !user.isLoggedIn && !(queryDict.t && queryDict.e)) {
      // User lost soft logged in params
      initializeMember();
    }
  }, [queryDict.t, queryDict.e]);

  useEffect(() => {}, [user]);

  const initializeMember = (user) => {
    bdaylytics.identify(user);
    setUser(user || {});
  };

  const getMember = async () => {
    const { errors, ...result } = await getUser(search);
    if (errors?.length > 0) {
      showAlert({ message: "There was a problem getting user data", type: "error" });
      initializeMember();
      setInitialized(true);
    } else if (result.user?.memberId && user.memberId && result.user.memberId !== user.memberId && pathname !== "/verify") {
      // Trigger logout if the soft login data is different from current logged in user
      setInitialized(false);
      await logout();
      initializeMember();
      getMember();
    } else {
      initializeMember(result.user);
      setInitialized(true);
    }
  };

  const updateMember = async (payload) => {
    if (payload.email && !(user.isLoggedIn || user.isSoftLoggedIn)) {
      const { errors, ...result } = await isUser(payload);
      if (errors?.length > 0) {
        showAlert({ message: "There was a problem checking user data", type: "error" });
        setUser({ ...user, ...payload });
      } else if (result.user) {
        const { isMember, membershipInfo } = result.user;
        setUser({ ...user, ...payload, isMember, membershipInfo });
      } else {
        setUser({ ...user, ...payload });
      }
    } else {
      setUser({ ...user, ...payload });
    }
  };

  const syncMembershipInfo = async () => {
    if (user.isLoggedIn || user.isSoftLoggedIn) {
      const { errors, membershipInfo } = await syncMembership(search);
      if (errors?.length > 0) {
        showAlert({ message: "There was a problem syncing membership data", type: "error" });
      } else if (membershipInfo) {
        await updateMember({ membershipInfo });
      }
    }
  };

  //logInfo(user);
  //logInfo(initialized);

  return (
    <MemberContext.Provider
      value={{ membershipInfo: { type: "logged-out" }, ...user, initialized, getMember, setMember: initializeMember, updateMember, syncMembershipInfo }}
    >
      {children}
    </MemberContext.Provider>
  );
};

export const useMember = () => useContext(MemberContext);
